module.exports = __webpack_public_path__ + "img/Infografis_EN_09.aa6b12da.jpg";